module.exports = __webpack_public_path__ + "img/250-mb-icon.77a2c3b5.png";